import i18next from 'i18next';

i18next.addResources('es', 'customMenu', {
  statistics: 'Estadística',
  searchsSummary: 'Detalle de Búsquedas',
  searchs: 'Búsquedas',
  sections: 'Secciones',
  events: 'Eventos',
  articles: 'Contenidos',
  projects: 'Proyectos',
  'draft-projects': 'Proyectos (borrador)',
  iirsaProjects: 'Portfolio de Proyectos',
  settings: 'Configuración',
  topics: 'Temas',
  routes: 'Agrupaciones de proyectos',
  layers: 'Capas (Shapefiles)',
  'projects-layer': 'Capa de Proyectos',
  parametricTables: 'Tablas paramétricas',
  priorizaciones: 'Priorizaciones',
  disclaimers: 'Disclaimers',
  etapas: 'Etapas',
  alcances: 'Alcances',
  'estados-estudios': 'Estados de Estudios',
  estados: 'Estados',
  'financiadores-estudios': 'Financiadores de Estudios',
  paises: 'Países',
  sectores: 'Sectores',
  subsectores: 'Subsectores',
  'tipos-proyecto': 'Tipos de Proyecto',
  metrics: 'Métricas',
  'metric-values': 'Valores de Métricas',
  administration: 'Administración',
  users: 'Usuarios'
});
